export default "__VITE_PUBLIC_ASSET__2194f591__"